/* =============================================
   BROKN — Composition & Entretien drawer
   ============================================= */

(function() {
  const trigger = document.querySelector('.brokn-fabric-care-trigger');
  const drawer = document.querySelector('.brokn-fabric-care-drawer');
  const overlay = document.querySelector('.brokn-fabric-care-overlay');
  const closeBtn = document.querySelector('.brokn-fabric-care-drawer__close');
  const content = document.getElementById('brokn-fabric-care-content');

  if (!trigger || !drawer) return;

  function openDrawer() {
    content.innerHTML = trigger.dataset.content;
    drawer.classList.add('is-open');
    overlay.style.display = 'block';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.style.display = 'none';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });
})();
